
<template>
<div class="tool-bar">
  <div class="inner-tool-bar">
    <div class="content left-content">
      <a :href="`${domain.SELLER_H5_URL}login`" target="_blank">
        <span class="inner">Seller Center</span>
      </a>
      <span class="inner app-inner">
        <img class="phone-icon" :src="$cvWebpFn('https://img.kilimall.com/c/h5/imgs/phone-icon@2x.png', { w: 80 })" alt="">
        <span>Download App</span>

        <div class="select-wrapper select-app-download-wrapper">
          <div class="select-wrapper-inner">
            <p class="app-title">Download our Cool FREE APP!</p>
            <p class="app-title-desc">Enjoy App-EXCLUSIVE Deals</p>
            <img class="download-img" v-lazy="$cvWebpFn('https://image.kilimall.com/lite/logo/qr-code.png')" alt="">

            <a href="/downloadApp" target="_blank">
              <img src="https://image.kilimall.com/kenya/PcImages/static/google-play.png" alt="" class="google-img">
            </a>
          </div>
        </div>
      </span>
    </div>
    <div class="content right-content">
      <!-- <div class="inner" style="margin-right: 10px;" @click="handleOpenLiveChatClick">
        <van-icon name="chat-o" badge="99+" size="24" />
      </div> -->
      <a href="/help-center/home?s_id=1004&bs_type=1&c_id=1020" target="_blank">
        <span class="inner">Help Center</span>
      </a>

      <div class="inner app-inner" v-if="useCountrys().value?.length > 0">
        <div class="region">
          <img :src="$cvWebpFn(currentRegion?.flag || '')" alt="" class="region-flag">
          <span class="cur-r-name">{{ currentRegion?.name || '' }}</span>
          <van-icon name="arrow-down" />
        </div>
        <div class="select-wrapper select-region-wrapper">
          <div class="select-wrapper-inner region-list">
            <div
              v-for="region in useCountrys().value || []"
              :key="region.id"
              class="region-item"
              @click="$switchCountry(region)"
            >
              <img class="region-flag" v-lazy="$cvWebpFn(region.flag)" alt="">
              <span>{{ region.name }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script setup lang="ts">
import domain from '@/server-config/domain.config'

const { $getCountry } = useNuxtApp()

const currentRegion = $getCountry()

// const handleOpenLiveChatClick = () => {
//   usePCLiveChatPopupShow().value = !usePCLiveChatPopupShow().value
// }
</script>

<style lang="scss" scoped>
$h:72px;
.tool-bar{
  background-color: #F5F7FA;
  height: $h;
  font-size: 32px;
  color: #666;
  .inner-tool-bar{
    width: var(--viewport-width);
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .content{
    flex: 1;
    height: $h;
    display: flex;
    align-items: center;
    .inner{
      display: flex;
      align-items: center;
      padding: 0 20px;
      position: relative;
      cursor: pointer;
      z-index: 2001;
      transition: color .2s;
      img{
        margin-right: 10px;
      }
      &:hover{
        color: var(--pc-default-color);
      }
      .region{
        display: flex;
        align-items: center;
        .cur-r-name{
          margin: 0 10px;
        }
      }
    }
  }
  .right-content{
    justify-content: flex-end;
    text-align: right;
  }
  .left-content{
    text-align: left;
  }
}
.select-region-wrapper{
  left: 0;
}
.select-app-download-wrapper{
  left: -50%;
}
.select-wrapper{
  background-color: #fff;
  box-shadow: 0 0 6px #999;
  border-radius: 12px;
  transition: all .2s;
  height: 0;
  overflow: hidden;
  position: absolute;
  top: 100%;
  z-index: 10001;
  .select-wrapper-inner{
    padding: 30px;
    background-color: #fff;
  }
  .app-title{
    font-weight: 600;
    font-size: 32px;
    padding: 0 7px;
  }
  .app-title-desc{
    margin: 20px 0;
    color: #333;
    padding: 0 7px;
  }
  .download-img{
    width: 100%;
    margin-bottom: 10px;
  }

  .region-list{
    .region-item{
      display: flex;
      margin-bottom: 20px;
      border-bottom: 1px solid #efefef;
      padding-bottom: 20px;
      cursor: pointer;
      color: #333;
      &:last-child{
        border-bottom: none;
        padding-bottom: 0;
      }
      &:hover{
        color: var(--pc-default-color);
      }
      align-items: center;
    }
  }
}
.app-inner {
  display: flex;
  align-items: center;
  height: $h;
  .phone-icon{
    height: 42px;
  }
}
.app-inner:hover .select-wrapper{
  height: auto;   
}
.region-flag{
  width: 60px;
  height: 40px;
}
</style>